<template>
  <div>


    <b-col
        md="12"
        sm="12"
    >
      <b-row>
        <b-form-group
            class="mb-0 col-2"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-75"
          />
        </b-form-group>

        <b-form-group
            class="mb-0 col-2"
        >
          <label class="d-inline-block text-sm-left mr-50">Vergangene Tage</label>
          <b-form-select
              id="perPageSelect"
              v-model="days"
              size="sm"
              :options="daysOptions"
              class="w-75"
          />
        </b-form-group>
        <div class="col-5"></div>
        <b-form-group
            class=" col-3 w-100"
            label="Datum"
            label-size="sm"
            label-for="filterInput"
        >
          <b-input-group size="sm">
            <b-form-datepicker
                class="ml-auto"
                v-model="filter"
                size="sm"
                :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                :start-weekday="1"
                locale="de-DE"
                color="danger"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-row>
    </b-col>

    <b-row v-for="d in 2">
      <b-col
          md="12"

          :loading="true"
      >
        <div v-if="loading" style="text-align: center; ">
          <b-spinner
              v-if="d == 1"
              key="primary"
              variant="light"
              class="mr-1"
              style="width: 5rem; height: 5rem; margin-top: 5em; margin-bottom: 5em;"
          />
        </div>

        <div v-else="loading">

          <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="d == 1 ? favouriteItems : items"
              :fields="fields"
          >
<!--            <template #cell(tripFullDuration)="data">-->
<!--              {{parseInt(data.item.tripFullDuration/60 / 60)}}-->
<!--            </template>-->
            <template #cell(showDate)="data">
              <div @click="Click(data.item.linkDay)">
                <div v-if="data.item.toDay == data.item.showDate">
                  <b-badge variant="success">
                    {{ data.item.showDate }}
                  </b-badge>
                </div>
                <div v-else style="font-size: 1.3em">
                  {{ data.item.showDate }}
                </div>

              </div>

            </template>

            <template #cell(vouchers)="data">
              <feather-icon
                  icon="MapIcon"
                  size="32"
                  :badge-classes="data.item.voucherCountNoDriver == 0 ? 'badge-success' : 'badge-danger'"
                  :class="data.item.voucherCountNoDriver == 0 ? 'text-success' : 'text-warning'"
                  :badge="data.item.vouchers-data.item.voucherCountNoDriver + '/' + data.item.vouchers "
              />

            </template>

            <template #cell(drivers)="data">
              <div style="width: 70vh">
                <b-badge v-for="dr in data.item.drivers" v-bind:style="{color: dr.Color2, background: dr.Color1, marginLeft: '0.2em', width: badgeWidth(dr.DId, data.item) +'%'}">{{ dr.DriverShortName }}</b-badge>
              </div>
            </template>
<!--            <template #cell(Action)="data">-->
<!--              <div-->
<!--                  @click="OpenPdf(data.item.linkDay)"-->
<!--              >-->
<!--                <b-avatar-->
<!--                    size="24"-->
<!--                    badge-->
<!--                    :src="require('@/assets/images/icons/pdf.png')"-->
<!--                    class="badge-minimal"-->
<!--                    badge-variant="danger"-->
<!--                />-->

<!--              </div>-->
<!--            </template>-->
          </b-table>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { retina } from 'leaflet/src/core/Browser'

export default {
  components: {
    BSpinner,
    BTable,
    BAvatar,
    BFormDatepicker,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      loading: true,
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      days: 3,
      daysOptions: [3, 7, 14, 31, 64, 128, 365, 1000],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'showDate',
          label: 'Tag',
        },
        {
          key: 'vouchers',
          label: 'Fahrten',
        },
        {
          key: 'drivers',
          label: 'Fahrer',
        },
      ],
      items: [],
      favouriteItems: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key,
          }))
    },

  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Dispoliste'
    })
    this.LoadList()
    // Set the initial number of items
    this.totalRows = this.items.length
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )

    this.$watch(
        () => this.days,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
  },
  methods: {
    badgeWidth(driver, item) {
      var h = (item.driversHours[driver]*100/item.tripFullDuration)/1.5;
      if(h < 7)
        return 7;

      return h;

    },
    OpenPdf(linkDay) {
      let url = `/disposition/get/pdf/${linkDay}`
      this.$http.get(url, { responseType: 'blob' })
          .then(resp => {
            window.open(URL.createObjectURL(resp.data))

          })
          .catch(err => {
            console.error(err)
          })

    },
    Click(linkDay) {
      this.$router.push({
        name: 'Disposition',
        params: { day: linkDay }
      })
    },
    LoadList() {

      this.items = []
      this.favouriteItems = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/disposition/list?from=${c1}&count=${this.perPage}&oldDays=${this.days}`
      if (this.filter != null && this.filter !== '') {

        let fD = new Date(this.filter)
        let ye = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(fD)
        let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(fD)
        let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(fD)

        url = `/disposition/list?from=${c1}&count=${this.perPage}&oldDays=${this.days}&year=${ye}&month=${mo}&day=${da}`
      }
      let lastID = 0
      this.$http.get(url, { timeout: 10 * 60 * 1000 })
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              lastID = i.vid
              let d = new Date(i.day)
              let ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(d)
              let mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(d)
              let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d)
              let weekday = new Intl.DateTimeFormat('de', { weekday: 'long' }).format(d)
              i.showDate = `${weekday}, ${da}.${mo}.${ye}`
              i.showDateJs = new Date(i.day.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1'))

              let toDayd = new Date()
              let toDayye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(toDayd)
              let toDaymo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(toDayd)
              let toDayda = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(toDayd)
              let toDaydaWeekday = new Intl.DateTimeFormat('de', { weekday: 'long' }).format(d)
              i.toDay = `${toDaydaWeekday}, ${toDayda}.${toDaymo}.${toDayye}`
              i.toDayJs = new Date('20' + toDayye + '-' + toDaymo + '-' + toDayda)
              if (i.toDayJs == i.showDateJs) {

                console.log(i.showDateJs)
                console.log(i.toDayJs)
                console.log('============================================')

              }
              // console.log(${toDayda}.${toDaymo}.${toDayye})

              i.linkDay = `20${ye}-${mo}-${da}`
              if (i.toDayJs == i.showDateJs) {
                this.favouriteItems.push(i)
              } else {
                this.items.push(i)
              }
            })
            this.loading = false
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
}
</script>
